export default function disableScroll() {
  document.body.style.overflow = "hidden";
  const x = window.scrollX;
  const y = window.scrollY;
  window.scrollTo(x, y);
  window.onscroll = function () {
    window.scrollTo(x, y);
  };
}
